export default function enqueueSnackbarWithSound(toast, playDone,
                                                 playSoundIfActive, message, variant) {
  if (!variant || variant == 'success') {
    toast.success(message)
  }
  if (playDone && playSoundIfActive){
    playSoundIfActive(playDone);
  }
}
